import { seriesEsp, seriesEng, seriesId, groupsEsp, groupsEng, unitsEsp, unitsEng } from './translations/translations_frp_rems.js'
import { translateSeries } from '../lib/translate_series_name.js'

export default class Visualizer {
  series = [];
  charts = [];

  RANGES_DEFAULT = [];
  CHARTS_DEFAULT = [];

  constructor(params) {
    this.charts = params || [];
    this.setDefaults();

    return {
      charts: this.charts.map(x => Object.assign(this.CHARTS_DEFAULT.find(y => y.type == x.type), x)),
      ranges: this.RANGES_DEFAULT,
      endpoints: {
        series: this.series,
        data: {
          build: () => {
            const sql = 'select * from rems ORDER BY ano, trimestre';
            const gobiertoPath = process.env.GOBIERTO_DATA_URL
            const token = process.env.GOBIERTO_DATA_TOKEN
            const query = `?sql=${sql}&token=${token}`;

            return `${gobiertoPath}/api/v1/data/data.json${query}`;
          },
          parse: data => {
            this.series = translateSeries(this.series, seriesEsp, seriesEng, seriesId, unitsEsp, unitsEng, groupsEsp, groupsEng)
            const series = this.series.map(d => ({
              id: d.id,
              name: d.name,
              units: d.units
            }));

            //Years and quarters are String we need to conver to Number
            let convertDateData = data.data
            convertDateData.forEach(d => {
              d.ano = +d.ano
              d.trimestre = +d.trimestre
            })

            // reorder the return data to be grouped by kind of serie
            const groupBySerie = series.map(set =>
              convertDateData.map(d => ({
                serie: set.id,
                time: new Date(d["ano"], (d["trimestre"] -1) * 3, 1),
                value: parseFloat(d[set.id]),
                name: set.name,
                units: set.units,
                idTooltip: "rem"
              }))
            );

            // give a flatted array
            return groupBySerie.flat();
          }
        }
      }
    };
  }

  setDefaults = () => {
    const series = [{
        id: "pibpm",
        group: "Economía"
      },
      {
        id: "vabpb_sndv",
        group: "Economía"
      },
      {
        id: "pibpr",
        group: "Economía"
      },
      {
        id: "c",
        group: "Economía"
      },
      {
        id: "cp",
        group: "Economía"
      },
      {
        id: "fbc",
        group: "Economía"
      },
      {
        id: "fbcf",
        group: "Economía"
      },
      {
        id: "ve",
        group: "Economía"
      },
      {
        id: "exp",
        group: "Economía"
      },
      {
        id: "imp",
        group: "Economía"
      },
      {
        id: "imp_bienes",
        group: "Economía"
      },
      {
        id: "imp_bienes_consumo",
        group: "Economía"
      },
      {
        id: "imp_bienes_capital",
        group: "Economía"
      },
      {
        id: "imp_bienes_intermedios",
        group: "Economía"
      },
      {
        id: "PIBpmcorr",
        group: "Economía"
      },
      {
        id: "k",
        group: "Economía"
      },
      {
        id: "ppm",
        group: "Deflactores"
      },
      {
        id: "pc",
        group: "Deflactores"
      },
      {
        id: "pcp",
        group: "Deflactores"
      },
      {
        id: "def_fbcf",
        group: "Deflactores"
      },
      {
        id: "px",
        group: "Deflactores"
      },
      {
        id: "pm",
        group: "Deflactores"
      },
      {
        id: "p",
        group: "Deflactores"
      },
      {
        id: "PFM",
        group: "Deflactores"
      },
      {
        id: "yw",
        group: "Deflactores"
      },
      {
        id: "n",
        group: "Población"
      },
      {
        id: "pa",
        group: "Población"
      },
      {
        id: "pob_mayor_16",
        group: "Población"
      },
      {
        id: "v",
        group: "Población"
      },
      {
        id: "ld",
        group: "Población"
      },
      {
        id: "ptetc",
        group: "Población"
      },
      {
        id: "ptetc_ld",
        group: "Población"
      },
      {
        id: "asa",
        group: "Población"
      },
      {
        id: "asatc",
        group: "Población"
      },
      {
        id: "ldg",
        group: "Población"
      },
      {
        id: "ldgbis",
        group: "Población"
      },
      {
        id: "tasa_paro",
        group: "Población"
      },
      {
        id: "ht",
        group: "Población"
      },
      {
        id: "w",
        group: "Población"
      },
      {
        id: "tp",
        group: "Población"
      },
      {
        id: "PIBpb",
        group: "Población"
      },
      {
        id: "e",
        group: "Energía"
      },
      {
        id: "pe",
        group: "Energía"
      },
      {
        id: "m1",
        group: "Energía"
      },
      {
        id: "m3",
        group: "Energía"
      },
      {
        id: "re",
        group: "Energía"
      },
      {
        id: "reu",
        group: "Energía"
      },
      {
        id: "er",
        group: "Energía"
      },
      {
        id: "tc",
        group: "Energía"
      },
      {
        id: "b",
        group: "Energía"
      },
      {
        id: "activos_financieros_netos",
        group: "Administración pública"
      },
      {
        id: "TR",
        group: "Administración pública"
      },
      {
        id: "P11R",
        group: "Administración pública"
      },
      {
        id: "P131R",
        group: "Administración pública"
      },
      {
        id: "D2R",
        group: "Administración pública"
      },
      {
        id: "D4R",
        group: "Administración pública"
      },
      {
        id: "D5R",
        group: "Administración pública"
      },
      {
        id: "D61R",
        group: "Administración pública"
      },
      {
        id: "D7R",
        group: "Administración pública"
      },
      {
        id: "D9R",
        group: "Administración pública"
      },
      {
        id: "TE",
        group: "Administración pública"
      },
      {
        id: "P2E",
        group: "Administración pública"
      },
      {
        id: "P5E",
        group: "Administración pública"
      },
      {
        id: "D1E",
        group: "Administración pública"
      },
      {
        id: "D29E",
        group: "Administración pública"
      },
      {
        id: "D3E",
        group: "Administración pública"
      },
      {
        id: "D4E",
        group: "Administración pública"
      },
      {
        id: "D_51p",
        group: "Administración pública"
      },
      {
        id: "D62E",
        group: "Administración pública"
      },
      {
        id: "D63PE",
        group: "Administración pública"
      },
      {
        id: "D7E",
        group: "Administración pública"
      },
      {
        id: "D9E",
        group: "Administración pública"
      },
      {
        id: "K2E",
        group: "Administración pública"
      },
      {
        id: "B9",
        group: "Administración pública"
      },
      {
        id: "ayudas_entidades",
        group: "Administración pública"
      },
      {
        id: "PDes",
        group: "Administración pública"
      },
      {
        id: "kpublico",
        group: "Administración pública"
      }
    ];

    if (this.charts[0].group) {
      const arrayOfGroup = this.charts[0].group
      this.series = series.filter((d) => arrayOfGroup.includes(d.group))
    } else {
      this.series = series
    }


    const range = (start, stop, step = 1) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);
    this.RANGES_DEFAULT = range(1980, 2023);

    this.CHARTS_DEFAULT = [{
        type: "Line",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        language: 'es',
        cache: true,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        }
      },
      {
        type: "Stacked",
        btnPlaceholder: "Añadir serie",
        xAxisProp: "time",
        yAxisProp: "value",
        aggregationProp: "serie",
        tooltip: this.tooltipCommon,
        language: 'es',
        cache: true,
        tickFormatY: (...args) => {
          const [d, , , d3] = args;

          return d < 1e3 ? d3.format("")(d) : d3.format("~s")(d);
        }
      }
    ];
  };
  getScale(key, d3) {
    const scales = {
      linear: d3.scaleLinear(),
      log: d3.scaleLog(),
      pow: d3.scalePow()
    };


    if (scales.hasOwnProperty(key)) {
      return scales[key];
    } else {
      return scales[0];
    }
  }
}
